import React from 'react';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { cn } from '@rocco/utils/cn';
import { DisplayMode } from '@rocco/types/enum/display-mode';
import type { FilterConfigModalItemDefault } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { SingleValueFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/single-value-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalSingleValue = (
    props: FilterModalElementProps<
        FilterConfigModalItemDefault,
        SingleValueFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate, displayMode } =
        props;
    const isMobile = displayMode === DisplayMode.Mobile;

    return (
        // A native <label> wrapping the checkbox makes the whole row (not just
        // the label text) an activation target. On mobile this is the primary
        // filter interaction, so the row is grown to a >=44px tap target;
        // desktop keeps its current (intrinsic) row height.
        <label
            htmlFor={filterConfigItem.filterKey}
            className={cn(
                'flex flex-row-reverse items-center justify-between pl-0',
                filterState.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                isMobile && 'min-h-11',
            )}
        >
            <RoccoCheckbox
                id={filterConfigItem.filterKey}
                checked={filterState.checked}
                disabled={filterState.disabled}
                onCheckedChange={(checked) => {
                    onFilterStateUpdate({ ...filterState, checked: !!checked });
                }}
            />
            <span
                className={cn(
                    'relative top-[2px] my-1.5 ml-0 text-sm leading-5',
                    filterState.disabled && 'opacity-50',
                )}
            >
                {filterConfigItem.label}
            </span>
        </label>
    );
};
